<div class="wrapper">
  <div class="slide-container swiper">
    <div class="slide-content swiper-wrapper">
      <div class="swiper-slide" *ngFor="let card of emcOptions; let i = index">
        <lib-card
          [value]="cardValues[i]"
          [label]="card.labelName"
          [showDropdown]="false"
          [showToggle]="false"
        ></lib-card>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</div>
